export const SECURITY_KEY = "SS23MJSOzRqzaupO4b!WERT!@#$mnyTf#$54";
export const BASE_API_URL = "https://etour.responseinfoway.com/";
export const BASE_restAPI_URL = "https://etourrestapi.responseinfoway.com/restApi/";



